import { createClient } from '@supabase/supabase-js';
import { isDemoMode } from './runtime';

const url = import.meta.env.VITE_SUPABASE_URL ?? '';
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ?? '';
export const supabase = !isDemoMode && url && key ? createClient(url, key) : null;
export const functionUrl = (name: string) => `${url}/functions/v1/${name}`;

async function invoke<T>(name: string, body?: unknown): Promise<T> {
  if (!supabase) throw new Error('Configura Supabase para producción.');
  const { data, error } = await supabase.functions.invoke(name, { body: body as Record<string, unknown> | undefined });
  if (error) {
    const response = (error as { context?: Response }).context;
    const detail = response ? await response.json().catch(() => null) as { error?: string } | null : null;
    throw new Error(detail?.error ?? error.message);
  }
  return data as T;
}
async function cloudinaryUpload(asset: Blob, config: Record<string, string | number | boolean>) {
  const form = new FormData();
  for (const [name, value] of Object.entries(config)) if (name !== 'cloudName') form.set(name, String(value));
  form.set('file', asset, 'moment.webp');
  const response = await fetch(`https://api.cloudinary.com/v1_1/${config.cloudName}/image/upload`, { method: 'POST', body: form });
  const body = await response.json();
  if (!response.ok) throw new Error(body.error?.message ?? 'Cloudinary no pudo recibir la foto.');
  return body as { public_id: string; bytes: number };
}
export async function submitToBackend(input: { email: string; language: 'es'|'en'; turnstileToken: string; display: Blob; thumb: Blob; width: number; height: number; sha256: string }) {
  if (isDemoMode) return null;
  const idempotencyKey = crypto.randomUUID();
  const session = await invoke<{ id:string; reference:string; display:Record<string,string|number|boolean>; thumb:Record<string,string|number|boolean> }>('create-upload-session', { email: input.email, language: input.language, turnstileToken: input.turnstileToken, width: input.width, height: input.height, sha256: input.sha256, consents: [true, true, true, true], idempotencyKey });
  const [display, thumb] = await Promise.all([cloudinaryUpload(input.display, session.display), cloudinaryUpload(input.thumb, session.thumb)]);
  await invoke('finalize-upload', { id: session.id, display, thumb });
  return session;
}
export async function adminApi<T>(body?: unknown) { return invoke<T>('admin', body); }
export async function displayFeed(token: string) {
  const response = await fetch(`${functionUrl('display-feed')}?channel=main&token=${encodeURIComponent(token)}`, { headers: { apikey: key } });
  const body = await response.json();
  if (!response.ok) throw new Error(body.error ?? 'No se pudo cargar la pantalla.');
  return body as { items: { id: string; url: string }[]; settings?: { duration?: number; density?: number } };
}
